import "./App.css";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { GallerySection } from "./components/GallerySection";
import { VisitSection } from "./components/VisitSection";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App bg-[#0d0b08] min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <GallerySection />
      <VisitSection />
      <Footer />
    </div>
  );
}

export default App;
